import * as ActionTypes from './../actionTypes';



export default (state={}, action) =>{

    switch(action.type){
        case ActionTypes.REQUEST_ORGANIZATION2:
                
            return {
                ...state,
                loading:true,
                error:false,
                errorInfo:null
            }
        
        case ActionTypes.RECEIVED_ORGANIZATION2:

            return {
                ...state,
                loading:false,
                response:action.res,
                error:false,
                errorInfo:null,
                etag: action.etag
            }

        case ActionTypes.ERROR_ORGANIZATION2:
            return{
                ...state,
                loading:false,
                error:true,
                errorInfo:action.err
            }
        case ActionTypes.SELECTED_CLASS_FROM_BOARD2:
            return {
                ...state,
                selectedBoard: action.selectedBoard
            }
        case ActionTypes.SELECT_GROUP_FROM_CLASS2:
            return {
                ...state,
                selectedClass: action.selectedClass
            }

        case ActionTypes.CLEAR_ORGANIZATION_DATA2:
            return {}   
        default: return state;

    }
} 